import request from "library/v1/request";

export function showSettings() {
  return request({
    url: 'settings',
    method: 'get'
  })
}
